import {WriteButton} from '../../common/buttons/WriteActions';
import {mobileDialogSx} from '../../common/dialogs/mobileDialogSx';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography,} from "@mui/material";
import {useState} from "react";
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";

interface Props {
    open: boolean;
    onClose: () => void;
    itemName: string;
    onDelete: () => boolean | void | Promise<boolean | void>;
    error?: string;
}

export const DeleteItemDialog = ({
                                     open,
                                     onClose,
                                     itemName,
                                     onDelete,
                                     error,
                                 }: Props) => {
    const {t} = useAppTranslation();
    const [confirmationText, setConfirmationText] = useState("");
    const [deleting, setDeleting] = useState(false);

    const isValid =
        confirmationText.trim() === itemName.trim();

    const handleClose = () => {
        setConfirmationText("");
        onClose();
    };

    const handleDelete = async () => {
        setDeleting(true);
        try {
            if (await onDelete()) handleClose();
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Dialog sx={mobileDialogSx} open={open} onClose={handleClose}>
            <DialogTitle>{t('items:delete_item')}</DialogTitle>

            <DialogContent>
                <Typography sx={{mb: 2}}>
                    {t('items:delete_item_confirmation')}
                </Typography>

                <Typography
                    color="error"
                    fontWeight={600}
                    sx={{mb: 2}}
                >
                    {itemName}
                </Typography>

                <TextField
                    fullWidth
                    label={t('items:item_name')}
                    value={confirmationText}
                    onChange={(e) =>
                        setConfirmationText(e.target.value)
                    }
                />
                {error && <Alert severity="error" sx={{mt: 2, whiteSpace: 'pre-line'}}>{error}</Alert>}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} disabled={deleting}>
                    {t('common:cancel')}
                </Button>

                <WriteButton
                    color="error"
                    variant="contained"
                    disabled={!isValid || deleting}
                    onClick={handleDelete}
                >
                    {t('common:delete')}
                </WriteButton>
            </DialogActions>
        </Dialog>
    );
};
